import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, InputSignal, Output, input } from '@angular/core';
import { RequirementsListItem } from 'app/api';

@Component({
    selector: 'requirements-list',
    imports: [CommonModule],
    templateUrl: './requirements-list.component.html',
    styleUrl: './requirements-list.component.scss',
})
export class RequirementsListComponent {
    @Input() selectionOn: boolean = false;
    @Input() selectedRequirement: RequirementsListItem | null = null;
    @Output() onRequirementSelected = new EventEmitter<RequirementsListItem>();

    requirements: InputSignal<Array<RequirementsListItem>> = input();

    selectRequirement(requirement: RequirementsListItem): void {
        if (!this.selectionOn) {
            return;
        }
        if (requirement.id === this.selectedRequirement?.id) {
            this.selectedRequirement = null;
        } else {
            this.selectedRequirement = requirement;
        }
        this.onRequirementSelected.emit(requirement);
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
